
export class ThinkListDisplaySearchModel {
    displaySearch: any;
    IgnoreList: any = [];
    noCrossList: any = [];
    orderList: any = [];
}



// WEBPACK FOOTER //
// ./src/app/components/think-list-display-search/think-list-display-search.model.ts